<template lang="html">
  <div class="ui-tab">
    <div class="ui-tab-item"
      v-for="(item, i) in list"
      :key="i"
      @click="$emit('change', i)">
      <span :class="{ 'try': hasTry&&i===1 , 'on': index === i}">{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UiTab',
  props: ['list', 'index', 'hasTry'],
  computed: {
  },
  created () {
    this.index = this.initIndex || 0
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.ui-tab {
  @include height(80);
  display: flex;
  border-bottom: 1px solid #E4E4E4;
  background-color: #fff;
  text-align: center;
  font-size: use(30);
  .try {
    &::before {
      content: '';
      position: absolute;
      top: rem(10);
      right: rem(-64);
      width: rem(64);
      height: rem(30);
      background: {
        image: url('../../assets/images/signup-icon-tab-try.png');
        repeat: no-repeat;
        size: contain;
      }
    }
  }
  &-item {
    @include center-box();
    flex: 1;

    span {
      @include height(80);
      display: block;
      position: relative;
      color: #999999;

      &.on {
        color: #444444;

        &:after {
          content: '';
          @include absolute('blw');
          height: 2px;
          background-color: $globalColor;
          border-radius: 1px;
        }
      }
    }
  }
}
</style>
